import * as actions from "../_actions/types";
import { firebaseApp } from "../firebase/firebase";

export const fetchNotifications = () => {
  return (dispatch, getState) => {
    const state = getState();
    const notifications = [];
    firebaseApp
      .database()
      .ref(`users/${state.auth.user.uid}/notifications`)
      .on('value', snapshot => {
        if (snapshot.val()) {
          Object.values(snapshot.val()).forEach(notification => {
            notifications.push(notification);
          })
        }
        dispatch({ type: actions.FETCH_NOTIFICATIONS, payload: notifications });
      })
  }
}

export const clearNotifications = (uid) => {
  return dispatch => {
    const clearNotifications = firebaseApp.functions().httpsCallable('clearNotifications')
    clearNotifications(uid).then(dispatch({ type: actions.CLEAR_NOTIFICATIONS}));
  }
}



// WEBPACK FOOTER //
// ./src/common/common_actions.js